export default __webpack_public_path__ + "static/media/background_1920-2.8e958fcb.jpg";